module.exports = __webpack_public_path__ + "static/impulso-bayer-4-89877a72989bfd5f35e37aac04708c6f.jpg";